(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbTabstripPanel', lbTabstripPanelDirective);

    function lbTabstripPanelDirective(lodash) {
        return {
            scope: {
                panel: '=',
                model: '='
            },
            controller: lbTabstripPanelDirectiveCtrl,
            templateUrl: "common/libraries/layoutBuilder/panels/tabstrip",
            link: lbTabstripPanelDirectiveLink
        };

        function lbTabstripPanelDirectiveLink (scope, elem) {
            var panels = [];

            angular.forEach(scope.panel.data.panels, function (val, index) {
                var visible = (function (showIf, model) {
                    if (typeof showIf === 'undefined') {
                        return true;
                    }
                    switch (showIf.operator) {
                        case 'eq':
                            return model[showIf.field] === showIf.value;
                    }
                })(val.showIf, scope.model);

                if (!visible) {
                    return;
                }

                var _html = '<lb-form-panel panel="panel.data.panels[' + index + '].panel" model="model"></lb-form-panel>';

                panels.push({
                    name: val.name,
                    panel: _html
                });
            });

            var dataSource = kendo.data.DataSource.create(panels);
            var kendoTabStripObj = elem.find('.k-tabstrip').data('kendoTabStrip');
            kendoTabStripObj.setDataSource(dataSource);
            kendoTabStripObj.select(0);

            scope.isActive = isActive;

            function isActive(panel) {
                var is_active = lodash.get(panel, 'is_active', false);
                return (is_active) ? "k-state-active" : '';
            }
        }
    }

    function lbTabstripPanelDirectiveCtrl($scope) {
        this.$onInit = function() {
            $scope.options = {
                animation:false,
                dataContentField: 'panel',
                dataTextField: 'name'
            };
        }
    }
})();
